<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal()")
        
    form.modal-main

        header.modal-header
            sectionHeader(:title="formTitle")
    
        div.modal-body

            //- LABEL
            div.form-section
                div.form-subsection
                    div.form-label__required
                        label Taxonomy Name
                    input.form-input(
                        v-model="taxonomyLabel"
                        placeholder="label"
                        autofocus
                        id="label"
                        name="label"
                        v-validate="'max:200|required|ascii|allowed_characters'"
                        type="text")
                    span.form-validate-error {{ errors.first('label') }}

            //- RETENTION
            div.form-section(v-if="type === 'create'")
                div.form-subsection-row.l-flex-row--between
                    div.form-label
                        label Retention
                    div.l-flex-row.l-align-center
                        div.form-radio-item.form-radio-item--left
                            input( type="radio" name="retention-30" value=30 id="retention-30" v-model="retention" checked)
                            label(for="retention-30") 30 days
                        div.form-radio-item.form-radio-item--right
                            input( type="radio" name="retention-395" value=395 id="retention-395" v-model="retention")
                            label(for="retention-395") 395 days

        //- FOOTER
        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
                button.btn.btn--medium.btn--round.btn-rev.btn-save-audience(
                    :class="{'ui-disabled': disabledButton}"
                    @click="handleActionTaxonomy()") {{ type }} taxonomy
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Validator } from 'vee-validate'

import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'TaxonomyForm',
    components: {
        SectionHeader
    },

    mounted() {
        if (this.type === 'edit') {
            this.taxonomyLabel = this.dataPayload.label
            this.initialLabel = this.dataPayload.label
        }
        Validator.extend('allowed_characters', {
            getMessage: () => 'Please use only letters, numbers, spaces, dashes or underscores',
            validate: value => RegExp('^[-_ a-zA-Z0-9]*$').test(value)
        })
        const instance = new Validator({ label: 'allowed_characters' })
        instance.attach('label', 'allowed_characters')
    },

    props: {
        dataPayload: { type: Object, required: true }
    },

    data() {
        return {
            taxonomyLabel: '',
            retention: 30,
            initialLabel: '',
            processing: false
        }
    },

    computed: {
        // Call to state
        ...mapState('account', {
            accountId: state => state.accountId
        }),
        ...mapState('ui/manageTaxonomy', {
            type: state => state.formTaxonomy.type
        }),

        formTitle() {
            return `${this.type} taxonomy`
        },

        isLabelUpdated() {
            return this.taxonomyLabel !== this.initialLabel
        },

        disabledButton() {
            return this.processing || !this.isLabelUpdated || !this.taxonomyLabel || this.errors.items.length > 0
        }
    },

    methods: {
        ...mapMutations('ui/manageTaxonomy', ['setTaxonomyForm']),
        ...mapActions('data/customTaxonomies', ['createTaxonomy', 'updateTaxonomy']),

        closeModal() {
            this.processing = false
            this.setTaxonomyForm({ displayModal: false, type: 'create' })
        },

        handleActionTaxonomy() {
            if (this.processing) return // Prevent multiple creation
            if (this.type === 'create') {
                const params = {
                    label: this.taxonomyLabel,
                    retention: this.retention,
                    taxonomy_type: 'custom'
                }
                this.createTaxonomy(params).finally(this.closeModal())
            } else if (this.type === 'edit') {
                const params = {
                    label: this.taxonomyLabel,
                    id: this.dataPayload.id
                }
                this.updateTaxonomy(params).finally(this.closeModal())
            }
        }
    }
}
</script>
